import type { ReactNode } from 'react';

interface Props {
    title: string;
    actions?: ReactNode;
    alert?: ReactNode;
    children?: ReactNode;
}

export function SessionNoteHeader({ title, actions, alert, children }: Props) {
    return (
        <div className="flex flex-col gap-8">
            <div className="flex items-center justify-between">
                <span className="font-bold text-2xl leading-none">{title}</span>
                {actions}
            </div>
            {alert && <div className="mb-2">{alert}</div>}
            {children}
        </div>
    );
}
